import template from './page-header.html';
import controller from './page-header.controller';

let pageHeaderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default pageHeaderComponent;



// WEBPACK FOOTER //
// ./client/common/page-header/page-header.component.js